module.exports = __webpack_public_path__ + "static/media/18.14f40c58.jpg";